import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse';

// Plugins are now registered centrally in gsap-config.js

window.scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};


// Alpine.js
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start()


//------------------//
// Lazy load images
// https://github.com/verlok/vanilla-lazyload
//------------------//
import Lazyload from 'vanilla-lazyload';

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
});
window.lazyLoadInstance = lazyLoadInstance;

// Re-scan for lazy images and scroll animations after Sprig/htmx swaps new content
document.addEventListener('htmx:afterSettle', (event) => {
    lazyLoadInstance.update();
    scrollAnimations.init(event.detail.target);
    scrollAnimations.refresh();
});


//------------------//
// Fancybox
// https://fancyapps.com
//------------------//
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
window.Fancybox = Fancybox;

// Homepage popup initialization
document.addEventListener('DOMContentLoaded', () => {
    const homePopup = document.getElementById('popup-home');
    if (homePopup) {
        Fancybox.show([{
            src: '#popup-home',
        }]);
    }
});

Fancybox.bind("[data-fancybox]", {
    // Enable captions (Fancybox v5 callback signature: fancybox, slide)
    caption: function (fancybox, slide) {
        return (slide && slide.caption) || "";
    },

    // Caption styling
    captionClass: "fancybox-caption",

    // Gallery options
    loop: true,
    buttons: [
        "zoom",
        "close"
    ],

    // Thumbnail navigation
    thumbs: {
        autoStart: false,
        axis: "x"
    },

    // Keyboard navigation
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "next",
        ArrowDown: "prev",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },

    // Touch gestures
    dragToClose: true,
    click: "close",
    clickContent: false,
    clickSlide: false,

    // Animation settings
    animated: true,
    showClass: "fancybox-zoomIn",
    hideClass: "fancybox-zoomOut",

    // Loading states
    loading: "lazy",
    preload: 1
});


//------------------//
// GSAP animations
//------------------//
import './fixed-scrolling-section';
import scrollAnimations from './scroll-animations';
import './menu-animations';

scrollAnimations.create();


//------------------//
// WeatherAPI.com
//------------------//
import initWeather from './weather.js';

// Initialize weather display
initWeather();
